import { Inject, Injectable } from '@angular/core';
import {
  STORAGE_MANAGER_TOKEN,
  StorageManager,
} from '../../../core/utils/storage/storageManager';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  readonly PLOT_DIGITIZATION_FORM_KEY: string = 'plot-digitization-form';
  readonly C_OF_O_APPLICATION_FORM_KEY: string = 'occupancy-application-form';
  readonly POWER_OF_ATTORNEY_APPLICATION_FORM_KEY: string =
    'power-of-attorney-application-form';
  readonly DEEDS_OF_ASSIGNMENT_APPLICATION_FORM_KEY: string =
    'deeds-of-assignment-application-form';
  readonly USER_KEY: string = 'user';
  readonly HAS_ACKNOWLEDGED_PLOT_DIGITIZATION_CHECKLIST: string =
    'has-acknowledged-plot-digitization-checklist';

  constructor(
    @Inject(STORAGE_MANAGER_TOKEN)
    private readonly storageManager: StorageManager,
  ) {}

  clearStorage(): Promise<void> {
    return this.storageManager.clearStorage();
  }

  remove(key: string): Promise<void> {
    return this.storageManager.remove(key);
  }

  persist(key: string, value: any): Promise<void> {
    return this.storageManager.persist(key, value);
  }

  async retrieve(key: string): Promise<any | null> {
    return this.storageManager.retrieve(key);
  }
}
